import { Component, Input, OnInit } from '@angular/core';
import { environment } from './../../../../environments/environment';

@Component({
	selector: 'app-cig-what-fuels-your-creativity',
	templateUrl: './cig-what-fuels-your-creativity.component.html',
	styleUrls: ['./cig-what-fuels-your-creativity.component.scss']
})
export class CigWhatFuelsYourCreativityComponent implements OnInit {
	@Input() slides;
	@Input() foursightassets;
	@Input() author;
	public env;

	constructor() { }

	ngOnInit() {
		this.env=environment;
	}

}
